import { connect } from 'react-redux';
import { getInputFormTradeWay } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.selectors';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';
import { getTabType } from 'state/workspaces/tabs/tabs.selector';

interface BidAskOwnProps {
  tabId: string;
}

interface BidAskStateProps {
  tradeWay?: TradeWay;
  bid?: number;
  ask?: number;
  unit?: string;
  isLive: boolean;
}

function mapStateToProps(state: AppState, { tabId }: BidAskOwnProps): BidAskStateProps {
  const tabType = getTabType(state, tabId);
  if (tabType === 'dlpProducts') {
    const metadata = fromSecondaryMarket.referential.dlpProduct.getProductSummaryFieldMetadata(state, tabId);
    const ccy = metadata?.find(i => i.id === 'currency')?.value as string;
    const priceType = metadata?.find(i => i.id === 'priceType')?.value;
    const unit = priceType === 'Percent' ? '%' : ccy;
    const bid =
      liveSelectors.getStreamingBidSettlementPrice(state, tabId)?.value ??
      liveReferentialSelectors.getBid(state, tabId);
    const ask =
      liveSelectors.getStreamingAskSettlementPrice(state, tabId)?.value ??
      liveReferentialSelectors.getAsk(state, tabId);
    const result = {
      bid,
      ask,
      unit,
      tradeWay: getInputFormTradeWay(state, tabId),
      isLive: liveSelectors.getStreamingStatus(state, tabId),
    };

    return result;
  } else {
    const ccy = liveReferentialSelectors.getCurrency(state, tabId);
    const priceType = liveReferentialSelectors.getPriceType(state, tabId);
    const unit = priceType === 'Percent' ? '%' : ccy;
    const bid =
      liveSelectors.getStreamingBidSettlementPrice(state, tabId)?.value ??
      liveReferentialSelectors.getBid(state, tabId);
    const ask =
      liveSelectors.getStreamingAskSettlementPrice(state, tabId)?.value ??
      liveReferentialSelectors.getAsk(state, tabId);
    const tradeWay =
      tabType === 'limitOrder'
        ? limitOrderSelectors.getFormTradeWay(state, tabId)
        : liveSelectors.getFormTradeWay(state, tabId);
    return {
      tradeWay,
      bid,
      ask,
      unit,
      isLive: liveSelectors.getStreamingStatus(state, tabId),
    };
  }
}

export const connectBidAsk = connect(mapStateToProps);
